export default __webpack_public_path__ + "static/media/sponsor-icon.1be49e75.webp";